import styled from 'styled-components'

const INK        = 'var(--vo-ink)';
const MUTED      = 'var(--vo-slate)';
const BLUE       = 'var(--color-brand)';
const BORDER     = 'var(--vo-cloud)';
const LIGHT_BG   = 'var(--vo-mist)';
const LABEL_COLOR = 'var(--vo-ink-2)';

/* ── Banner ───────────────────────────────────────── */
export const BannerCard = styled.div`
  background: white;
  border-radius: 14px;
  padding: 16px 20px;
  box-shadow: 0 1px 3px var(--vo-escuro-8);
  border-left: 4px solid ${BLUE};
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 16px;
`

export const BannerText = styled.div`
  flex: 1;
`

export const BannerTitle = styled.p`
  font-family: 'Maven Pro', sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: ${INK};
  margin: 0 0 2px;
`

export const BannerDesc = styled.p`
  font-family: 'Lato', sans-serif;
  font-size: 13px;
  color: ${MUTED};
  margin: 0;
  line-height: 1.55;
`

/* ── Filters ──────────────────────────────────────── */
export const FilterCard = styled.div`
  background: white;
  border-radius: 14px;
  padding: 16px 24px;
  box-shadow: 0 1px 3px var(--vo-escuro-8);
  margin-bottom: 16px;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 14px;
`

export const FilterField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  ${({ $flex }) => $flex ? 'flex: 1; min-width: 180px;' : ''}
`

export const FilterLabel = styled.label`
  font-family: 'Maven Pro', sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: ${MUTED};
`

/* ── Table ────────────────────────────────────────── */
export const TableCard = styled.div`
  background: white;
  border-radius: 14px;
  box-shadow: 0 1px 3px var(--vo-escuro-8);
  overflow: hidden;
`

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`

export const TableHead = styled.thead`
  background: ${LIGHT_BG};
`

export const Th = styled.th`
  font-family: 'Maven Pro', sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: ${MUTED};
  text-transform: uppercase;
  letter-spacing: .08em;
  padding: 12px 16px;
  text-align: ${({ $right }) => $right ? 'center' : 'left'};
  border-bottom: 1px solid ${BORDER};
  white-space: nowrap;
`

export const TableBody = styled.tbody``

export const Tr = styled.tr`
  border-bottom: 1px solid ${LIGHT_BG};
  &:last-child { border-bottom: none; }
  &:hover { background: var(--vo-capri-25); }
`

export const Td = styled.td`
  padding: 12px 16px;
  vertical-align: middle;
`

/* ── Cell content ─────────────────────────────────── */
export const VendorName = styled.p`
  font-family: 'Maven Pro', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: ${INK};
  margin: 0;
`

export const FrameworkText = styled.span`
  font-family: 'Lato', sans-serif;
  font-size: 13px;
  color: ${LABEL_COLOR};
`

export const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  font-family: 'Maven Pro', sans-serif;
  font-size: 12px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 20px;
  white-space: nowrap;
  color: ${({ $color }) => $color};
  background: ${({ $bg }) => $bg};
`

export const ScoreBadge = styled.span`
  display: inline-flex;
  align-items: center;
  font-family: 'Maven Pro', sans-serif;
  font-size: 12px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 20px;
  white-space: nowrap;
  color: ${({ $color }) => $color};
  background: ${({ $bg }) => $bg};
`

export const NoScoreText = styled.span`
  font-family: 'Lato', sans-serif;
  font-size: 12px;
  color: var(--vo-steel);
  font-style: italic;
`

export const DateText = styled.span`
  font-family: 'Lato', sans-serif;
  font-size: 13px;
  color: ${MUTED};
`

export const ActionsCell = styled(Td)`
  text-align: center;
`

/* ── Footer ───────────────────────────────────────── */
export const TableFooter = styled.div`
  padding: 12px 20px;
  border-top: 1px solid ${LIGHT_BG};
`

export const FooterText = styled.span`
  font-family: 'Lato', sans-serif;
  font-size: 13px;
  color: ${MUTED};
`

/* ── Empty / Loading ──────────────────────────────── */
export const EmptyCell = styled.td`
  text-align: center;
  padding: 32px 16px;
  font-family: 'Lato', sans-serif;
  font-size: 14px;
  color: ${MUTED};
`

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 32px;
`
